<template>
  <el-collapse v-model="activeRows" @change="onCollapse">
    <el-collapse-item
      data-test-subform-row
      v-for="(row, rowIdx) in rows"
      :key="`${rowIdx}-${row.rowUid}-comp`"
      :name="row.rowUid"
      class="subform-row-container"
    >
      <template slot="title">
        <div class="p-1 d-flex align-items-center w-100">
          <i class="el-icon-arrow-down me-3 subform-row__expand" :class="{ 'is-expanded': isExpanded(row.rowUid) }"></i>
          <div class="lh-1 me-3 subform-row__title text-break">{{ getTitle(path, rowIdx) }}</div>
          <i
            v-if="removable"
            class="el-icon-delete ms-auto subform-row__remove"
            @click="onRemoveRowClick(rowIdx, row.rowUid)"
          ></i>
        </div>
      </template>
      <div class="p-2">
        <sub-form-row
          v-if="checkIfRendered(row.rowUid)"
          class="w-100"
          :path="`${path}/${rowIdx}`"
          :key="`sub-${rowIdx}-${row.rowUid}-comp`"
          :row-id="rowIdx"
          :list-head="listHead"
          :read-only="readOnly"
          :row-index="rowIdx"
          :name="name"
          :removable="removable"
          @remove-row-click="onRemoveRowClick"
        />
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { last } from 'lodash'
import subFormViewMixin from './mixin-sub-form-view'
import EventBus from '../../../utils/event-bus'

export default {
  name: 'SubformCollapsibleGridView',
  mixins: [subFormViewMixin],
  data() {
    return {
      activeRows: [],
      removableRow: null,
      renderedRows: [],
    }
  },
  methods: {
    onCollapse() {
      if (this.removableRow) {
        const { rowUid, collapsed } = this.removableRow
        collapsed ? this.removeActiveRow(rowUid, collapsed) : this.addActiveRow(rowUid)
        this.removableRow = null
      }

      this.handleRow()
    },
    handleRow() {
      const lastAddedRow = last(this.activeRows)
      const needToBeRendered = !this.checkIfRendered(lastAddedRow)

      if (needToBeRendered) this.renderedRows.push(lastAddedRow)
    },
    isExpanded(rowUid) {
      return this.activeRows.includes(rowUid)
    },
    removeActiveRow(rowUid) {
      const index = this.activeRows.indexOf(rowUid)
      this.activeRows.splice(index, 1)
    },
    addActiveRow(rowUid) {
      this.activeRows.push(rowUid)
    },
    onRemoveRowClick(rowIndex, rowUid) {
      const index = this.activeRows.indexOf(rowUid)
      this.removableRow = { rowUid, collapsed: index === -1 }
      this.$emit('remove-row-click', rowIndex)
    },
    getTitle(path, rowIdx) {
      return (
        this.$get('subFormRowPrimaryInListValue')(`${path}/${rowIdx}`) ||
        this.$i18n.t('default_collapsible_subform_row_title')
      )
    },
    checkIfRendered(rowUid) {
      return this.renderedRows.includes(rowUid)
    },
    handleAddRow(rowUid) {
      this.renderedRows.push(rowUid)
      this.activeRows = [rowUid]
    },
  },
  created() {
    EventBus.$on(`added-sub-form-row-${this.id}`, ({ rowUid }) => this.handleAddRow(rowUid))
  },
  beforeDestroy() {
    EventBus.$off(`added-sub-form-row-${this.id}`)
  },
}
</script>

<style scoped lang="scss">
.subform-row__title {
  font-size: $font-size;
}
.subform-row__remove {
  font-size: $h2-font-size;
}
.subform-row__remove,
.subform-row__title {
  color: $color-text-regular;
}
.subform-row:nth-child(even) {
  background-color: $table-header;
}
.is-expanded {
  transform: rotate(-180deg);
}
.subform-row__expand {
  transition: 0.4s;
}
</style>
<style lang="scss">
.subform-row-container {
  .el-collapse-item__arrow {
    display: none !important;
  }
}
</style>
